import clsx from "clsx"
import { Command } from "cmdk"

import { SelectListGroupProvider } from "./SelectListGroup.context"
import styles from "./SelectListGroup.module.scss"
import { SelectListGroupProps } from "./SelectListGroup.types"

export default function SelectListGroup(props: SelectListGroupProps) {
    const { children, value, className } = props

    return (
        <SelectListGroupProvider>
            <Command.Group value={value} className={clsx(styles.base, className)}>
                {children}
            </Command.Group>
        </SelectListGroupProvider>
    )
}
